export const BASE_URL = 'http://localhost:3000'
// export const BACKEND_URL = 'http://localhost/api'
export const BACKEND_URL = 'https://viguro.name/api'
export default { BASE_URL, BACKEND_URL }
